import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'

export const useSearchWordStore = defineStore('searchWord', () => {
  interface SearchWord {
    form: Form,
    suggest: {
      search: SuggestWordItem[],
      access: SuggestWordItem[],
    },
  }
  const context: SearchWord = reactive({
    form: {
      action: '',
      method: 'get',
    },
    suggest: {
      search: [],
      access: [],
    }
  })

  /**
   * 検索フォームの情報が正しく受け取れているかどうか
   */
  const isValidForm = computed<boolean>(() => !!context.form.action)

  /**
   * 検索サジェストが存在しているかどうか
   */
  const hasSuggest = computed<boolean>(() => {
    return !!context.suggest.search.length || !!context.suggest.access.length
  })

  return {
    // data
    context,

    // computed
    isValidForm,
    hasSuggest,
  }
})
